import React, { createContext, } from "react";
import EngageRouter from "./router";
import { createEngageContext } from "./context";
export var ConfigContext;
export function createEngageApp(appConfig, initialAppState, initialUserState) {
    var _a = createEngageContext(initialAppState, initialUserState), context = _a.context, Provider = _a.Provider;
    ConfigContext = createContext(appConfig);
    var AppComponent = function (props) {
        return (React.createElement(ConfigContext.Provider, { value: appConfig },
            React.createElement(Provider, null,
                React.createElement(EngageRouter, { overrideRoutes: props.overrideRoutes, roleComponents: props.roleComponents, createLobbyExtension: props.createLobbyExtension, addtlComponents: props.addtlComponents }))));
    };
    return {
        context: context,
        AppComponent: AppComponent
    };
}
//# sourceMappingURL=index.js.map